"use strict";
'use es6'; // This is the new version of the QueryTaskPlaylistStore

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _generalStore = _interopRequireDefault(require("general-store"));

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _LocalSettings = require("crm_data/settings/LocalSettings");

var ElasticSearchAPI = _interopRequireWildcard(require("crm_data/elasticSearch/api/ElasticSearchAPI"));

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var _QueryTaskPlaylistConstants = require("crm_data/queues/QueryTaskPlaylistConstants");

var _TaskPlaylistConfigRecord = _interopRequireDefault(require("crm_data/queues/TaskPlaylistConfigRecord"));

var _TaskPlaylistActionTypes = require("./TaskPlaylistActionTypes");

var _shouldFetchMorePlaylistTasks = _interopRequireDefault(require("./utils/shouldFetchMorePlaylistTasks"));

var initialState = (0, _immutable.fromJS)({
  config: null,
  configIsLoaded: false,
  isFetchingMore: false,
  hasMore: false
});

function getConfig() {
  var configData = (0, _LocalSettings.getFrom)(sessionStorage, _QueryTaskPlaylistConstants.PLAYLIST_CONFIG_KEY);

  if (!configData) {
    return null;
  }

  return _TaskPlaylistConfigRecord.default.fromJS(configData);
}

function updateConfig(config) {
  (0, _LocalSettings.setFrom)(sessionStorage, _QueryTaskPlaylistConstants.PLAYLIST_CONFIG_KEY, config.toJS());
}

var _default = _generalStore.default.defineFactory().defineName('TaskPlaylistStore').defineGetInitialState(function () {
  return initialState;
}).defineGet(function (state, key) {
  var __options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  switch (key) {
    case 'title':
    case 'currentTaskAssociationId':
    case 'currentTaskAssociationType':
    case 'currentTaskId':
    case 'taskIds':
    case 'redirectUrl':
    case 'total':
      {
        if (!state.get('configIsLoaded')) {
          (0, _Dispatch.dispatchQueue)(_TaskPlaylistActionTypes.TASK_PLAYLIST_LOAD_CONFIG);
          return _LoadingStatus.LOADING;
        }

        return state.getIn(['config', key]);
      }

    default:
      {
        if (key) {
          return state.get(key);
        }

        return state;
      }
  }
}).defineResponseTo(_TaskPlaylistActionTypes.TASK_PLAYLIST_LOAD_CONFIG, function (state) {
  var config = getConfig();

  if (!config) {
    return state.set('configIsLoaded', true);
  }

  var pageSize = config.pageSize,
      taskIds = config.taskIds,
      total = config.total,
      currentTaskId = config.currentTaskId;
  var currentIndex = taskIds.indexOf(currentTaskId);

  if ((0, _shouldFetchMorePlaylistTasks.default)({
    currentIndex: currentIndex,
    pageSize: pageSize,
    taskIds: taskIds,
    total: total
  })) {
    (0, _Dispatch.dispatchQueue)(_TaskPlaylistActionTypes.TASK_PLAYLIST_FETCH_MORE);
  }

  return state.merge({
    config: config,
    configIsLoaded: true,
    hasMore: config ? taskIds && taskIds.size < total : false
  });
}).defineResponseTo(_TaskPlaylistActionTypes.TASK_PLAYLIST_SET_CURRENT_TASK, function (state, _ref) {
  var currentTaskId = _ref.currentTaskId,
      currentTaskAssociationId = _ref.currentTaskAssociationId,
      currentTaskAssociationType = _ref.currentTaskAssociationType,
      interaction = _ref.interaction;
  var updatedConfig = state.get('config').merge({
    currentTaskId: currentTaskId,
    currentTaskAssociationId: currentTaskAssociationId,
    currentTaskAssociationType: currentTaskAssociationType,
    interaction: interaction
  });
  updateConfig(updatedConfig);
  return state.set('config', updatedConfig);
}).defineResponseTo(_TaskPlaylistActionTypes.TASK_PLAYLIST_FETCH_MORE, function (state) {
  if (state.get('isFetchingMore')) {
    return state;
  }

  var _state$get = state.get('config'),
      query = _state$get.query,
      taskIds = _state$get.taskIds;

  var moreTasksQuery = query.set('offset', taskIds.size);
  ElasticSearchAPI.search(_ObjectTypes.TASK, moreTasksQuery).then(function (response) {
    var moreTaskIds = response.get('engagements').toList();
    var total = response.get('total');
    var hasMore = response.get('has-more', false);
    (0, _Dispatch.dispatchQueue)(_TaskPlaylistActionTypes.TASK_PLAYLIST_SET_FETCH_MORE_RESULTS, {
      moreTaskIds: moreTaskIds,
      total: total,
      hasMore: hasMore
    });
  });
  return state.set('isFetchingMore', true);
}).defineResponseTo(_TaskPlaylistActionTypes.TASK_PLAYLIST_SET_FETCH_MORE_RESULTS, function (state, _ref2) {
  var moreTaskIds = _ref2.moreTaskIds,
      total = _ref2.total,
      hasMore = _ref2.hasMore;
  var updatedConfig = state.get('config').set('total', total).update('taskIds', function (taskIds) {
    var allTaskIds = taskIds.concat(moreTaskIds);
    return allTaskIds.filter(function (taskId, index) {
      return allTaskIds.indexOf(taskId) === index;
    });
  });
  updateConfig(updatedConfig);
  return state.set('isFetchingMore', false).set('hasMore', hasMore).set('config', updatedConfig);
}).defineResponseTo(_TaskPlaylistActionTypes.TASK_PLAYLIST_EXIT, function (state) {
  (0, _LocalSettings.deleteFrom)(sessionStorage, _QueryTaskPlaylistConstants.PLAYLIST_CONFIG_KEY);
  return state.set('config', null);
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;